import React from 'react';
import DocumentComposer from '../components/DocumentComposer';

const TaxInvoicePage = () => (
  <DocumentComposer
    pageTitle="Tax Invoice PDF"
    documentTitle="TAX INVOICE"
    numberLabel="Tax Invoice No"
    numberField="taxInvoiceNo"
    numberPlaceholder="e.g. TI-001"
    filePrefix="TaxInvoice"
    accentColor="#0f766e"
    titleBarColor="#115e59"
    pdfButtonColor="linear-gradient(135deg, #0f766e, #14b8a6)"
    footerNote="This tax invoice is generated electronically and is valid without a signature."
    totalLabel="Total"
    taxLabel="GST"
    showFreightAmountField
  />
);

export default TaxInvoicePage;
